const CheckIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 50 50"
      fill="currentColor"
      {...props}
    >
      <path
        d="M20 35 L10 25 L12.5 22.5 L20 30 L37.5 12.5 L40 15 L20 35 Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default CheckIcon;
